function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Translate } from "../../../../../I18N";
import { InputField } from "../../../../Components/Forms";
import { useForm } from 'react-hook-form';
import { Button, Card } from "../../../../Components/UI";









const Form = ({ closePanel, submit, relationtype, currentTypes }) => {var _errors$name;
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    values: relationtype,
    mode: 'onSubmit'
  });

  return (/*#__PURE__*/
    _jsx("div", { className: "relative h-full" }, void 0, /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(submit), id: "relationship-type-form" }, void 0, /*#__PURE__*/
    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Relationship Type") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "relationship-type-name",
      "data-testid": "relationship-type-form-name",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Name") },
    register('name', {
      required: true,
      validate: {
        alreadyExists: (value) => !currentTypes.some((type) => type.name === value)
      }
    }), {
      hasErrors: !!errors.name,
      errorMessage:
      ((_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.type) === 'alreadyExists' ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Already exists") : null })

    )
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex absolute bottom-0 gap-2 px-4 py-3 w-full" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "light",
      onClick: closePanel,
      className: "grow",
      "data-testid": "relationship-type-form-cancel" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, {
      className: "grow",
      type: "submit",
      form: "relationship-type-form",
      "data-testid": "relationship-type-form-submit" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Save")
    )
    )
    ));

};

export { Form };